import * as React from 'react';
export const UnhandledActionContext = /*#__PURE__*/React.createContext(undefined);
//# sourceMappingURL=UnhandledActionContext.js.map